import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["children", "loading", "icon", "iconAlign", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from "react";
import useControls from "../core/hooks/useControls";
import { Spinner } from "../Spinner";
import { ButtonTitle, ButtonWrapper } from "./Button.styles";
var Button = /*#__PURE__*/forwardRef(function (_ref, reference) {
  var children = _ref.children,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      icon = _ref.icon,
      _ref$iconAlign = _ref.iconAlign,
      iconAlign = _ref$iconAlign === void 0 ? "left" : _ref$iconAlign,
      sizeProperty = _ref.size,
      properties = _objectWithoutProperties(_ref, _excluded);

  var _useControls = useControls({
    size: sizeProperty
  }),
      size = _useControls.size;

  return /*#__PURE__*/React.createElement(ButtonWrapper, _extends({}, properties, {
    iconOnly: !children,
    hasIcon: Boolean(icon),
    iconAlign: iconAlign,
    size: size,
    loading: Boolean(loading)
  }, reference ? {
    ref: reference
  } : {}), iconAlign === "left" && icon, children && /*#__PURE__*/React.createElement(ButtonTitle, null, children), iconAlign === "right" && icon, Boolean(loading) && /*#__PURE__*/React.createElement(Spinner, {
    position: "absolute",
    size: size,
    variant: typeof loading === "string" ? loading : "light"
  }));
});
Button.displayName = "Button";
export default Button;